module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_6-9c2bbb1d47a1571a53088556d8e2309b.jpg";